import React from "react";
import { Container } from "react-bootstrap";
import skillCategories from "../../data/skills";
import "./Skills.css";

function Skills() {
  const getLevelClass = (level) => {
    switch (level) {
      case "operational":
        return "level-operational";

      case "hands-on":
        return "level-hands-on";

      case "developing":
        return "level-developing";

      default:
        return "";
    }
  };

  const getLevelText = (level) => {
    switch (level) {
      case "operational":
        return "Operational";

      case "hands-on":
        return "Hands-on";

      case "developing":
        return "Developing";

      default:
        return level;
    }
  };

  return (
    <section className="skills-section" id="skills">
      <Container>
        <div className="skills-header">
          <span className="skills-badge">Capabilities</span>

          <h2 className="skills-title">
            Technical <span className="skills-accent">Skills</span>
          </h2>
        </div>

        <div className="skills-grid">
          {skillCategories.map((category) => (
            <article
              key={category.id}
              className={`skill-category-card ${
                category.priority ? "primary-category" : ""
              }`}
            >
              <div className="category-header">
                <div className="category-icon" aria-hidden="true">
                  {category.icon}
                </div>

                <div className="category-heading">
                  <div className="category-title-row">
                    <h3 className="category-title">
                      {category.title}
                    </h3>

                    {category.priority && (
                      <span className="category-priority">
                        {category.priority}
                      </span>
                    )}
                  </div>
                </div>
              </div>

              <div className="category-divider"></div>

              <div className="category-skills">
                {category.skills.map((skill) => (
                  <div
                    key={`${category.id}-${skill.name}`}
                    className="category-skill-item"
                  >
                    <div className="skill-info">
                      <span className="skill-name">
                        {skill.name}
                      </span>

                      <span className="skill-desc">
                        {skill.description}
                      </span>
                    </div>

                    <span
                      className={`skill-level ${getLevelClass(
                        skill.level
                      )}`}
                    >
                      {getLevelText(skill.level)}
                    </span>
                  </div>
                ))}
              </div>
            </article>
          ))}
        </div>
      </Container>
    </section>
  );
}

export default Skills;